// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconBulletList = createRemixIcon('IconBulletList', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.75 7.25V.75h6.5v6.5zm0 8v-6.5h6.5v6.5zm0 1.5v6.5h6.5v-6.5zM9 5.25h14v-2.5H9zm14 8H9v-2.5h14zm-14 8h14v-2.5H9z\" clip-rule=\"evenodd\"/>");
